/*#__PURE__*/ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { compare } from "compare-versions";
import { defaultSnapOrigin } from "./index";
import { SUPPORTED_METAMASK_VERSION } from "./consts/index";
export const getProvider = function() {
    var _ref = _async_to_generator(function*() {
        let mmFound = false;
        if ('detected' in window.ethereum) {
            for (const provider of window.ethereum.detected){
                try {
                    // Detect snaps support
                    yield provider.request({
                        method: 'wallet_getSnaps'
                    });
                    // enforces MetaMask as provider
                    window.ethereum.setProvider(provider);
                    mmFound = true;
                    return provider;
                } catch (e) {}
            }
        }
        // no-op
        if (!mmFound && 'providers' in window.ethereum) {
            for (const provider of window.ethereum.providers){
                try {
                    // Detect snaps support
                    yield provider.request({
                        method: 'wallet_getSnaps'
                    });
                    window.ethereum = provider;
                    mmFound = true;
                    return provider;
                } catch (e) {}
            }
        }
        // no-op
        return window.ethereum;
    });
    return function getProvider() {
        return _ref.apply(this, arguments);
    };
}();
export const getWalletSnaps = function() {
    var _ref = _async_to_generator(function*() {
        return yield window.ethereum.request({
            method: 'wallet_getSnaps'
        });
    });
    return function getWalletSnaps() {
        return _ref.apply(this, arguments);
    };
}();
export const isMetamaskInstalled = function() {
    var _ref = _async_to_generator(function*() {
        try {
            const provider = yield getProvider();
            return Boolean(provider === null || provider === void 0 ? void 0 : provider.isMetaMask);
        } catch (e) {
            return false;
        }
    });
    return function isMetamaskInstalled() {
        return _ref.apply(this, arguments);
    };
}();
export const isSnapInstalled = function() {
    var _ref = _async_to_generator(function*(snapOrigin, version) {
        try {
            yield getProvider();
            const snapId = snapOrigin !== null && snapOrigin !== void 0 ? snapOrigin : defaultSnapOrigin;
            return Boolean(Object.values((yield getWalletSnaps())).find((permission)=>permission.id === snapId && (!version || permission.version === version)));
        } catch (e) {
            console.log('Failed to obtain installed snaps', e);
            return false;
        }
    });
    return function isSnapInstalled(snapOrigin, version) {
        return _ref.apply(this, arguments);
    };
}();
export const checkSnapSupport = function() {
    var _ref = _async_to_generator(function*() {
        var _window_ethereum, _window_ethereum_request, _version_match;
        const version = yield window === null || window === void 0 ? void 0 : (_window_ethereum = window.ethereum) === null || _window_ethereum === void 0 ? void 0 : (_window_ethereum_request = _window_ethereum.request) === null || _window_ethereum_request === void 0 ? void 0 : _window_ethereum_request.call(_window_ethereum, {
            method: 'web3_clientVersion'
        });
        var _version_match_;
        const currentVersion = (_version_match_ = (_version_match = version.match(/\/v?(\d+\.\d+\.\d+)/u)) === null || _version_match === void 0 ? void 0 : _version_match[1]) !== null && _version_match_ !== void 0 ? _version_match_ : null;
        const isMobile = version.endsWith('Mobile');
        return compare(currentVersion, SUPPORTED_METAMASK_VERSION, '>=') && !isMobile;
    });
    return function checkSnapSupport() {
        return _ref.apply(this, arguments);
    };
}();

//# sourceMappingURL=utils.js.map